import { DetailViewCard } from '../CardWithTitle';
import { useEffect, useState, useMemo } from 'react';
import { ComponentSpinner } from '../Loading/ComponentSpinner';
import { InventoryAsset, VoiceDetailsRecord } from '../../../types';
import { Text } from '../../Atoms/Text';
import { TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { NavLink } from 'react-router-dom';

export function VoiceDetails({ data }: { data: InventoryAsset }) {
  const [isFetching, setIsFetching] = useState<boolean>(true);
  const [records, setRecords] = useState<VoiceDetailsRecord[]>([]);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    setIsFetching(false);
    setRecords(sortedRecords());
  }, [data?.phoneNumbers]);

  const sortedRecords = () => {
    return [...(data?.phoneNumbers || [])].sort((a, b) => {
      if (a.status === 'Active' && b.status !== 'Active') return -1;
      if (a.status !== 'Active' && b.status === 'Active') return 1;
      return 0;
    });
  };

  const filteredRecords = useMemo(() => {
    if (!searchTerm) return records;
    return records.filter((record) => record.phoneNumber.toLowerCase().includes(searchTerm.toLowerCase()));
  }, [records, searchTerm]);

  const renderRow = (record: VoiceDetailsRecord, index: number) => (
    <div
      className={`flex py-4 ${index > 0 ? 'border-t border-grey-2' : ''}`}
      key={index}>
      <Text
        className="font-sans text-grey-4 w-full"
        size="sm14">
        {record.status}
      </Text>
      <Text
        className="font-sans font-normal w-full"
        size="sm">
        {record.phoneNumber}
      </Text>
    </div>
  );

  const renderContent = () => {
    return (
      <>
        <div className="max-w-xs">
          <TextField
            placeholder="Search Phone Numbers..."
            variant="outlined"
            size="small"
            fullWidth
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
            sx={{ mb: 2 }}
          />
        </div>
        {filteredRecords.length === 0 && <div className="text-center text-grey-4">No Phone Numbers found</div>}
        {filteredRecords.slice(0, 2).map((record, index) => renderRow(record, index))}
        <div className="mt-4">
          <NavLink
            to={`/phone-numbers?recordId=${data.id}`}
            className="text-indigo text-sm">
            All Phone Numbers
          </NavLink>
        </div>
      </>
    );
  };

  return (
    <DetailViewCard
      enableCollapse
      collapsed
      title={`Voice Details (${records.length || 0})`}
      childrenWrapperClass="overflow-x-auto">
      <div className="font-sans text-black">
        {isFetching && <ComponentSpinner label="Loading" />}
        {!isFetching && !records.length && <div className="text-center">No Phone Numbers</div>}
        {!isFetching && !!records.length && renderContent()}
      </div>
    </DetailViewCard>
  );
}
